const endpoints = {
  attachment: "/attachment",
  login: "/user-management/login",
  create_password: "/user-management/create-password",
  password_reset: "/user-management/reset-password",
  forgot_password: "/user-management/forgot-password",
  me: "/user-management/me",
  logout: "/user-management/logout",
  get_user: "/user-management/users",
  add_user: "/user-management/users",
  set_user_filter: "/core/admin/filter",
  get_product_brand: "/brand-management/brands",
  delete_product_brand: "/brand-management/brands",
  add_product_brand: "/brand-management/brands",
  update_product_brand: "/brand-management/brands",
  show_product_brand: "/brand-management/brands",
  set_product_brand_filter: "/core/brands/filter",
  get_roles: "/user-management/roles",
  get_permissions: "/user-management/permissions",
  get_states: "/user-management/states",
  get_user_brands: "/brand-management/user-brands",
  get_invoices: "/zoho-management/invoice",
  get_options: "/zoho-management/get-filters",
};
export default endpoints;
